import React, { useState, useEffect } from "react"
import { useAuth0 } from '@auth0/auth0-react';
import { useWindowSize } from 'usehooks-ts';
import { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack'
import Navbar from './navbar'
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router'
import { Backdrop, Container, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material'
import Home from '../pages/home'
import AppConfig from "../../appConfig";
import { convertArrayToDictionary, defaultGuid, getAuthToken, getUserId } from "../../common/utils";
import { getFreshAuthToken, startAuthSession } from "../../common/authSession";
import Loader from "./spinners/loader";
import Errors from '../pages/errors/unauthorized'
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchCompanies,
  companiesSelector,
} from "../../store/slices/company";
import {
  fetchInternalLocations,
  fetchLocations,
  locationsSelector,
} from "../../store/slices/location";
import { updateScreenSize } from '../../store/slices/connections';
import CircularProgress from '@mui/material/CircularProgress';
import Reviews from "../pages/reviews"
import Topics from "../sections/topics"
import Sentiments from "../pages/sentiments";
import { fetchBrandVoice, brandVoiceSelector } from "../../store/slices/brandVoice"
import Prompts from "../pages/prompts";
import Pipelines from "../pages/pipelines";
import Cubes from "../pages/cubes";
import moment from "moment";
import { getStandardTopicsData, getTopicsData } from "../../store/slices/topics";
import { fetchprompts } from "../../store/slices/prompts";
import { fetchReviews } from "../../store/slices/reviews";
import { bindFilters, filtersSelector } from "../../store/slices/fliters";
import LocalFalcon from "../components/localFalcon"
import RolePermissions from "../pages/rolePermissions/rolePermissions";
import Chat from "../pages/uploadJSON/Chat";
// import RolePermissions from "../pages/rolePermissions";
import ls from "@livesession/sdk";
import Gbp from "../pages/gbp";
import Facts from "../pages/facts";
import { endDateChangeFunction, localSelector, rangeChangeFunction, selectedCompanyChangeFunction, selectedLocationChangeFunction, startDateChangeFunction } from "../../store/slices/local";

const signalR = require("@microsoft/signalr");
const isRMP = _.includes(['testrmp', 'prodrmp'], AppConfig.appMode) ? true : false;

const App = () => {
  const { isLoading, isAuthenticated, user, loginWithRedirect, getAccessTokenSilently } = useAuth0();
  // const [range, setRange] = useState("[0,0,1]");
  const userRoles = user?.["userRoles/roles"]?.roles  ? user?.["userRoles/roles"]?.roles : user?.["rightresponse.ai/roles"]?.roles;
  const authToken = getAuthToken();
  // const [selectedCompany, setSelectedCompany] = useState("");
  const [livesession, setLivesession] = useState(false);
  const [env, setEnv] = useState(sessionStorage.getItem('env') && _.includes(AppConfig.envs, sessionStorage.getItem('env')) ? sessionStorage.getItem('env') : AppConfig.appMode);
  // const [selectedLocation, setSelectedLocation] = useState("all");
  const [connection, setConnection] = React.useState();
  const [connected, setConnectionState] = React.useState();
  const { companies, loadingCompany } = useSelector(companiesSelector);
  const { locations, brandVoice, loadingLocation } = useSelector(locationsSelector);
  const { loadingSetFilter, loadingGetFilter } = useSelector(filtersSelector);
  const { startDate, endDate, range, selectedCompany, selectedLocation } = useSelector(localSelector)
  // const { brandVoice } = useSelector(brandVoiceSelector);
  // const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  // const [startDate, setStartDate] = useState(
  //   moment().startOf("year").year(2023).format("YYYY-MM-DD")
  // );
  const dispatch = useDispatch()
  const setStartDate = (date) => {
    dispatch(startDateChangeFunction(date));
  }
  const setEndDate = (date) => {
    dispatch(endDateChangeFunction(date));
  }
  const setRange = (range) => {
    dispatch(rangeChangeFunction(range));
  }
  const setSelectedCompany = (companyId) => {
    dispatch(selectedCompanyChangeFunction(companyId));
  }
  const setSelectedLocation = (locationId) => {
    dispatch(selectedLocationChangeFunction(locationId));
  }
  const navigate = useNavigate();
  const location = useLocation();
  const { width, height } = useWindowSize()
  const authorized = React.useMemo(() => _.includes(user?.email, '@insightresults.com')
    || _.includes(user?.email, '@l2analytics.com') || _.includes(user?.email, '@rightresponseai.com'), [user, authToken && userRoles])
  const isIRUser = React.useMemo(() => userRoles?.indexOf("IRUser") >= 0, [userRoles]);
  const companyDic = React.useMemo(() => convertArrayToDictionary(companies, 'companyId'), [companies])

  const userId = React.useMemo(() => getUserId(), [isIRUser]);
  // Renew an expired sign-in, or ask the user to sign in again, instead of letting API calls fail silently.
  useEffect(() => startAuthSession({ getAccessTokenSilently, loginWithRedirect }), [getAccessTokenSilently, loginWithRedirect]);
  useEffect(() => {
    if (!connected && authToken) {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl((AppConfig.signalRAutoRefreshUrl + "?env=" + env),
          {
            accessTokenFactory: getFreshAuthToken,
            // headers: {env: "test"}
          })
        .withHubProtocol(new MessagePackHubProtocol())
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: retryContext => {
            // Suppress retry errors in console
            return Math.min(1000 * Math.pow(2, retryContext.previousRetryCount), 30000);
          }
        })
        .build();
      setConnection(newConnection);
    }

  }, [authToken, connected]);

  useEffect(() => {
    if (connection && !connected) {
      connection.start()
        .then(() => {
          const connectionId = connection.connectionId;
          const trackerId = AppConfig.liveSessionId;
          if (trackerId) {
            ls.init(trackerId, { keystrokes: true, rootHostname: selectedCompany },);
            ls.identify({ first_time_visit: false, userId: userId, email: user?.email, name: user?.name, fist_name: user?.nickname, })
            // ls.setCustomParams({
            //     email: user?.email, name: user?.name,
            //     fist_name: user?.nickname,
            //     userId: userId,
            //     params: {
            //         account_id: connectionId,
            //         plan: "premium"
            //     }
            // });
            ls.newPageView();
            setLivesession(true)
          }
          console.log('Connected!');
          sessionStorage.setItem('tabId', connectionId);
          setConnectionState(true);
        })
        .catch((err) => {
          console.log("message: " + err);
          if (err?.message?.includes("Unauthorized")) {
            loginWithRedirect();
          }
        });
    }
  }, [connection]);


  useEffect(() => {

    if (authToken && userRoles && connected) {
      if (!(sessionStorage.getItem('env') && _.includes(AppConfig.envs, sessionStorage.getItem('env')))) {
        sessionStorage.setItem('env', env)
      }

      localStorage.setItem('userId', _.replace(_.find(userRoles, role => { return _.includes(role, 'userid') }), 'userid:', ''));

      const tabId = sessionStorage.getItem('env')

      if (JSON.parse(localStorage.getItem('company')) && companyDic[JSON.parse(localStorage.getItem('company'))[tabId]] && tabId) {
        setSelectedCompany(JSON.parse(localStorage.getItem('company'))[tabId])
      }
      else {
        setSelectedCompany(companies[0]?.companyId);
        if (companies[0]?.companyId) {
          const tabId = sessionStorage.getItem('env')
          let localCompanyIds = JSON.parse(localStorage.getItem('company')) ?? {}
          localCompanyIds[tabId] = companies[0]?.companyId

          localStorage.setItem('company', JSON.stringify(localCompanyIds))
        }
      }
      updateScreenSize(`${width}*${height}`);

    }
  }, [authToken, userRoles, connected, companyDic]);

  useEffect(() => {
    if (authToken && userRoles && connected) {
      dispatch(fetchCompanies());
    }
  }, [authToken, userRoles, connected]);

  useEffect(() => {
    if (selectedCompany && !loadingCompany) {
      const trackerId = AppConfig.liveSessionId;
      if (trackerId && livesession) {
        // ls.init(trackerId, { keystrokes: true, rootHostname: connectionId },);
        ls.setCustomParams({
          email: user?.email, name: user?.name,
          fist_name: user?.nickname,
          userId: userId,
          params: {
            companyId: selectedCompany,
            companyName: companyDic?.[selectedCompany]?.name,
            subscriptionStatus: companyDic?.[selectedCompany]?.subscriptionStatus
          }
        });
        // dispatch(setLiveSession(true))
      }
      dispatch(fetchLocations(selectedCompany, env));
      dispatch(fetchInternalLocations(selectedCompany));
      dispatch(getTopicsData(selectedCompany));
    }
  }, [selectedCompany, loadingCompany, env])
  const getLocation = () => {
    const filter =
      localStorage.getItem("filter") &&
      JSON.parse(localStorage.getItem("filter"))?.[selectedCompany];
    let locationId = filter ? filter?.locations : [defaultGuid]; //_.sortBy(locations, 'state', 'city');

    return {

      location: locationId,
      filter,
    };
  };
  const filterState = React.useMemo(() => getLocation(), [selectedCompany])
  useEffect(() => {
    const filters = filterState?.filter
    if (filters) {
      if (filters?.timePeriod?.start) {
        // setStartDate(filters?.timePeriod?.start);
      }
      if (filters?.timePeriod?.end) {
        // setEndDate(filters?.timePeriod?.end);
      }
      if (filters?.timePeriod?.range) {
        setRange(filters?.timePeriod?.range);
      }
      if (filters?.locations) {
        const tempLocation = filters?.locations[0]
        setSelectedLocation(tempLocation === defaultGuid ? 'all' : tempLocation)
      }
    }
  }, [filterState])
  useEffect(() => {
    if (selectedCompany && !loadingCompany && !loadingLocation) {

      let bindLocationIds = selectedLocation === 'all' ? [defaultGuid] : [selectedLocation]
      let bindFilterObj = {
        companyId: selectedCompany,
        Locations: bindLocationIds,
        // competitorLocations: competitorLocationIds,
        TimePeriod: null,
      };
      if (startDate) {
        bindFilterObj["TimePeriod"] = {
          Range: range,
          Start: moment(startDate).format("YYYY-MM-DD"),
          End: moment(endDate).format("YYYY-MM-DD"),
        };
      }
      dispatch(bindFilters(bindFilterObj));
    }
  }, [
    startDate,
    endDate,
    loadingLocation,
    selectedLocation
    // competitorLocationIds,
  ]);
  useEffect(() => {
    if (!authorized && authToken && userRoles) {
      navigate('/error/unauthorized', { replace: true })
    }
    // else{
    //     navigate('/home', { replace: true }) 
    // }

  }, [authorized, authToken, userRoles, location.pathname])
  useEffect(() => {
    if (
      selectedCompany !== null &&
      selectedCompany !== undefined &&
      selectedCompany !== "" &&
      !loadingSetFilter &&
      startDate !== null &&
      startDate !== undefined &&
      startDate !== "" &&
      endDate !== null &&
      endDate !== undefined &&
      endDate !== "" && !loadingLocation && !loadingCompany
    ) {

      dispatch(fetchReviews(selectedLocation === 'all' ? defaultGuid : selectedLocation));
    }
  }, [loadingGetFilter]);
  const companyData = React.useMemo(
    () => _.find(companies, { companyId: selectedCompany }),
    [companies, selectedCompany]
  );
  useEffect(() => {
    if (companyData && !loadingCompany) {
      dispatch(getStandardTopicsData(companyData?.businessType))
    }
  }, [companyData?.businessType, loadingCompany])

  if (isLoading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: "login",
      }
    });
  }

  if (!authorized && authToken && userRoles) {
    return (<Routes>
      <Route path="/error/unauthorized" element={<Errors />} />
    </Routes>)
  }
  return (authorized && isAuthenticated &&
    <div>
      <Navbar range={range} setRange={setRange} setConnectionState={setConnectionState} setEnv={setEnv} env={env} pathname={_.toLower(location.pathname)} userRoles={userRoles} setSelectedCompany={setSelectedCompany} selectedCompany={selectedCompany} companies={companies} setSelectedLocation={setSelectedLocation} selectedLocation={selectedLocation} locations={locations} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
      {loadingCompany && <Backdrop open={loadingCompany} sx={{ zIndex: 10 }}><Stack sx={{ position: 'relative' }} direction='row'><Typography variant="h4" color={'#fff'}>Refreshing Snapshot</Typography><div style={{ position: 'absolute', right: -30, bottom: 10 }}><div className="dot-typing"></div></div></Stack></Backdrop>}
      <Container sx={{ maxWidth: { lg: '100%', xl: '100%' }, ml: '64px', width: 'calc(100% - 64px)', p: 0, height: 'calc(100vh - 48px)' }}>
        <Routes>
          {/* <Route path="/home" element={<Home />} /> */}
          <Route path="/responses" element={<Reviews startDate={startDate} endDate={endDate} brandVoiceData={brandVoice} setSelectedCompany={setSelectedCompany} selectedCompany={selectedCompany} selectedLocation={selectedLocation} userRoles={userRoles} setSelectedLocation={setSelectedLocation} locations={locations} />} />
          {(<Route path="/sentiments" element={<Sentiments startDate={startDate} endDate={endDate} setSelectedCompany={setSelectedCompany} selectedCompany={selectedCompany} selectedLocation={selectedLocation} userRoles={userRoles} setSelectedLocation={setSelectedLocation} locations={locations} />} />)}
          <Route path="/topics" element={<Topics startDate={startDate} endDate={endDate} selectedSubMenu={10} companyId={selectedCompany} selectedLocation={selectedLocation} userRoles={userRoles} />} />
          <Route path="/prompts" element={<Prompts selectedEnv={env} startDate={startDate} endDate={endDate} isIRUser={isIRUser} setSelectedCompany={setSelectedCompany} selectedCompany={selectedCompany} selectedLocation={selectedLocation} userRoles={userRoles} setSelectedLocation={setSelectedLocation} locations={locations} />} />
          <Route path="/pipelines" element={<Pipelines startDate={startDate} endDate={endDate} isIRUser={isIRUser} setSelectedCompany={setSelectedCompany} selectedCompany={selectedCompany} selectedLocation={selectedLocation} userRoles={userRoles} setSelectedLocation={setSelectedLocation} locations={locations} />} />
          {<Route path="/ranking" element={<LocalFalcon startDate={startDate} endDate={endDate} isIRUser={isIRUser} setSelectedCompany={setSelectedCompany} selectedCompany={selectedCompany} selectedLocation={selectedLocation} userRoles={userRoles} setSelectedLocation={setSelectedLocation} locations={locations} />} />}
          {<Route path="/cubes" element={<Cubes isIRUser={isIRUser} userRoles={userRoles} />} />}
          {<Route path="/Cubes" element={<Navigate to="/cubes" replace={true} />} />}
          {<Route path="/rolePermissions" element={<RolePermissions isIRUser={isIRUser} userRoles={userRoles} />} />}
          {<Route path="/chats" element={<Chat isIRUser={isIRUser} userRoles={userRoles} />} />}
          {<Route path="/facts" element={<Facts isIRUser={isIRUser} userRoles={userRoles} selectedCompany={selectedCompany} />} />}
          {<Route path="/gbp" element={<Gbp isIRUser={isIRUser} userRoles={userRoles} />} />}
          <Route path="*" element={<Navigate to="/prompts" replace={true} />} />
        </Routes>
      </Container>

    </div>
  )
}

export default App
